import MuiBox from '@mui/material/Box';
import MuiGrid from '@mui/material/Grid';
import {IconButton as MuiIconButton, Link as MuiLink, Paper as MuiPaper, Stack, styled, Typography as MuiTypography} from "@mui/material";
import LinkedIn from "@mui/icons-material/LinkedIn";
import XIcon from '@mui/icons-material/X';
import {MAX_CONTENT_WIDTH, MIN_CONTENT_WIDTH} from "./utils/Constants";

const Box = styled(MuiBox)({
    width: "100%",
    marginTop: "auto",
});

const Paper = styled(MuiPaper)(({theme}) => ({
    backgroundColor: theme.palette.admin.main,
    color: theme.palette.admin.contrastText,
    padding: '0.5rem 0.5rem 1.5rem 0.5rem',
}));

const Link = styled(MuiLink)(({theme}) => ({
    color: theme.palette.admin.contrastText,
    textDecoration: 'none',
    "&:hover": {
        color: theme.palette.payLevels.main,
    }
}));

const IconButton = styled(MuiIconButton)(({theme}) => ({
    color: theme.palette.admin.contrastText,
    "&:hover": {
        color: theme.palette.payLevels.main,
    }
}));

const Typography = styled(MuiTypography)(() => ({
    fontSize: "13px",
    height: "16px",
}));

const BaseGridItem = styled(MuiGrid)(({theme}) => ({
    display: "flex",
    width: "100%",
    [theme.breakpoints.up('xs')]: {
        alignItems: "center",
        justifyContent: 'center',
    },
}));

const RightGridItem = styled(BaseGridItem)(({theme}) => ({
    [theme.breakpoints.up('md')]: {
        alignItems: "center",
        justifyContent: 'flex-end',
    }
}));

const ContactLinks = styled(MuiGrid)(({theme}) => ({
    width: '100%',
    [theme.breakpoints.up('xs')]: {
        maxWidth: MIN_CONTENT_WIDTH,
    },
    [theme.breakpoints.up('md')]: {
        maxWidth: MAX_CONTENT_WIDTH,
        paddingLeft: '0.5rem',
    }
}));

const ContactLink = ({label, href}) => {
    const LeftGridItem = styled(BaseGridItem)(({theme}) => ({
        [theme.breakpoints.up('md')]: {
            alignItems: "center",
            justifyContent: 'flex-start',
        }
    }));

    return (
        <LeftGridItem size={{xs: 1, md: 'auto'}}>
            <Link fontSize="small" href={href}>{label}</Link>
        </LeftGridItem>
    );
};

const AddressDetails = styled(ContactLinks)(() => ({
    paddingTop: '1rem',
    paddingBottom: '0.5rem',
    borderTop: "2px solid rgba(255, 255, 255, 0.2)",
}));

const AddressItems = ({children}) => {
    const LeftGridItem = styled(BaseGridItem)(({theme}) => ({
        [theme.breakpoints.up('md')]: {
            alignItems: "flex-start",
            justifyContent: 'flex-start',
        }
    }));

    const AddressStack = styled(Stack)(({theme}) => ({
        display: "flex",
        [theme.breakpoints.up('xs')]: {
            alignItems: "center",
            justifyContent: 'center',
        },
        [theme.breakpoints.up('md')]: {
            alignItems: "flex-start",
            justifyContent: 'flex-start',
        }
    }));

    return (
        <LeftGridItem size={{xs: 1, md: 'auto'}}>
            <AddressStack>
                {children}
            </AddressStack>
        </LeftGridItem>
    );
};

const Footer = () => {
    return (
        <Box component="footer">
            <Paper elevation={0} square>
                <Stack alignItems="center" sx={{width: "100%"}}>
                    <ContactLinks container spacing={{xs: 0, md: 6}} columns={{xs: 1, md: 12}}>
                        <ContactLink label="Contact" href="https://www.incomesdataresearch.co.uk/contact"/>
                        <ContactLink label="Website Privacy Policy" href="https://www.incomesdataresearch.co.uk/privacy-policy"/>
                        <ContactLink label="Terms & Conditions for Subscriptions" href="https://www.incomesdataresearch.co.uk/terms-and-conditions"/>
                        <RightGridItem size={{xs: 1, md: 'grow'}}>
                            <Stack direction="row" spacing={0}>
                                <IconButton href="https://www.linkedin.com/company/incomes-data-research/">
                                    <LinkedIn/>
                                </IconButton>
                                <IconButton href="https://twitter.com/payclimate">
                                    <XIcon/>
                                </IconButton>
                            </Stack>
                        </RightGridItem>
                    </ContactLinks>

                    <AddressDetails container spacing={{xs: 1, md: 6}} columns={{xs: 1, md: 12}}>
                        <AddressItems>
                            <Typography>Incomes Data Research Limited</Typography>
                            <Typography>71-75 Shelton Street,</Typography>
                            <Typography>Covent Garden,</Typography>
                            <Typography>London, WC2H 9JQ</Typography>
                        </AddressItems>

                        <AddressItems>
                            <Typography>Registered in England & Wales</Typography>
                            <Typography>Company Number: 09327550</Typography>
                            <Typography>VAT Number: 201 3872 45</Typography>
                        </AddressItems>

                        <AddressItems>
                            <Typography>Copyright © 2025 Incomes Data Research. All rights reserved.</Typography>
                        </AddressItems>
                    </AddressDetails>
                </Stack>
            </Paper>
        </Box>
    );
};

export default Footer;
